import { useQuery } from "react-query";
import { Key_subscriptionStatisticsByCourse } from "../utils/constants";
import { getSubscriptionStatisticsByCourse } from "../services/school/student/getSubscriptionStatisticsByCourse";
import { PagedRequestType } from "../types/PagedResults";

export const useGetSubscriptionStatisticsByCourse = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [Key_subscriptionStatisticsByCourse, JSON.stringify(data)],
    () => getSubscriptionStatisticsByCourse(data),
    options?{...options}:{}
  );
